import React from 'react';
import { Collapse } from 'antd';
import { useTranslation } from 'react-i18next';

import Colors from '../../../../../themes/Colors';

import SelectionCardComponent from '../../../../../components/SelectionCardComponent';
import CampaignInfoPanel from './CampaignInfoPanel';
import ContentsLibraryPanelHeader from './ContentsLibraryPanel';
import ContentsPanel, { ContentsPanelHeader } from './ContentsPanel';
import ContentsLibraryContainer from '../../containers/ContentsLibraryContainer';

const { Panel } = Collapse;

const customPanelStyle = {
  background: Colors.snow,
  borderRadius: 4,
  marginBottom: 24,
  border: 0,
  overflow: 'auto',
  boxShadow: 'rgba(0, 0, 0, 0.25) 1px 2px 4px 0px'
};

const customPanelStyleContent = {
  borderTopWidth: '0px',
  borderLeftWidth: '0px',
  borderRightWidth: '0px'
};

const StepOne = ({
  // estado del padre
  creationType,
  setCreationType,
  errors = {},
  inputCharLimit = {},
  areaCharLimit = {},
  blockCreationType,
  subsidized_all,

  // redux / store
  campaignName,
  campaignDescription,
  categoriesId,
  categories = [],
  isCampaignPaused,
  isCampaignTest,
  cart = [],
  editCampaignActive,
  currentCampaign,
  isSuperUser,
  user,

  // handlers
  setCampaignName,
  setCampaignDescription,
  changeSubsidizedPrice,
  changeCategory,
  setIsCampaignPaused,
  setIsCampaignTest,
  resetCampaignData,
  allDisplaysAreOwn
}) => {
  const { t } = useTranslation();

  const panelOneHeader =
    creationType === 'makeProposal' ||
    (editCampaignActive && currentCampaign && currentCampaign.status === 'proposal')
      ? t('Your proposal')
      : t('Your campaign');

  return (
    <>
      {!editCampaignActive && (
        <div
          className="contentFilter campaingInfoCard customPanelStyleDisplays"
          style={{ border: errors['creationType'] ? `1px solid ${Colors.red}` : 'none' }}
        >
          <SelectionCardComponent
            creationType={creationType}
            setCreationType={setCreationType}
            errors={errors}
            blockCreationType={blockCreationType}
            resetCampaignData={resetCampaignData}
          />
        </div>
      )}

      <Collapse defaultActiveKey={['1', '2', '3']} style={customPanelStyleContent}>
        {/* Panel 1: Datos de la campaña */}
        <Panel header={panelOneHeader} key="1" style={customPanelStyle}>
          <CampaignInfoPanel
            errors={errors}
            inputCharLimit={inputCharLimit}
            areaCharLimit={areaCharLimit}
            subsidized_all={subsidized_all}
            campaignName={campaignName}
            campaignDescription={campaignDescription}
            categoriesId={categoriesId}
            categories={categories}
            isCampaignPaused={isCampaignPaused}
            isCampaignTest={isCampaignTest}
            editCampaignActive={editCampaignActive}
            currentCampaign={currentCampaign}
            isSuperUser={isSuperUser}
            user={user}
            allDisplaysAreOwn={allDisplaysAreOwn}
            setCampaignName={setCampaignName}
            setCampaignDescription={setCampaignDescription}
            changeSubsidizedPrice={changeSubsidizedPrice}
            changeCategory={changeCategory}
            setIsCampaignPaused={setIsCampaignPaused}
            setIsCampaignTest={setIsCampaignTest}
          />
        </Panel>

        {/* Panel 2: Biblioteca de contenidos */}
        {(creationType === 'createCampaign' || editCampaignActive) && (
          <Panel
            header={
              <ContentsLibraryPanelHeader />
            }
            key="2"
            style={customPanelStyle}
          >
            <ContentsLibraryContainer />
          </Panel>
        )}

        {/* Panel 3: Contenidos de la campaña */}
        {((!editCampaignActive && creationType) || editCampaignActive) && (
          <Panel
            header={
              <ContentsPanelHeader
                errors={errors}
                cart={cart}
                creationType={creationType}
                editCampaignActive={editCampaignActive}
              />
            }
            key="3"
            style={customPanelStyle}
          >
            <ContentsPanel errors={errors} currentCampaign={currentCampaign} />
          </Panel>
        )}
      </Collapse>
    </>
  );
};

export default StepOne;
